import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { settings } from '@pixi/settings';
var CanvasRenderTarget = /*#__PURE__*/function () {
  function CanvasRenderTarget(width, height, resolution) {
    _classCallCheck(this, CanvasRenderTarget);
    this.canvas = settings.ADAPTER.createCanvas();
    this.context = this.canvas.getContext("2d");
    this.resolution = resolution || settings.RESOLUTION;
    this.resize(width, height);
  }
  _createClass(CanvasRenderTarget, [{
    key: "clear",
    value: function clear() {
      this.context.setTransform(1, 0, 0, 1, 0, 0);
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }, {
    key: "resize",
    value: function resize(desiredWidth, desiredHeight) {
      this.canvas.width = Math.round(desiredWidth * this.resolution);
      this.canvas.height = Math.round(desiredHeight * this.resolution);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.context = null;
      this.canvas = null;
    }
  }, {
    key: "width",
    get: function get() {
      return this.canvas.width;
    },
    set: function set(val) {
      this.canvas.width = Math.round(val);
    }
  }, {
    key: "height",
    get: function get() {
      return this.canvas.height;
    },
    set: function set(val) {
      this.canvas.height = Math.round(val);
    }
  }]);
  return CanvasRenderTarget;
}();
export { CanvasRenderTarget };